const swPaintColors = [
  { name: 'Mulberry Silk', code: '#94766C' },
  { name: 'Chelsea Mauve', code: '#BEAC9F' },
  { name: 'Cabbage Rose', code: '#C59F91' },
  { name: 'Rose Brocade', code: '#996C6E' },
  { name: 'Deepest Mauve', code: '#6D595A' },
  { name: 'Toile Red', code: '#8B534E' },
  { name: 'Decorous Amber', code: '#AC7559' },
  { name: 'Cajun Red', code: '#8D422F' },
  { name: 'Eastlake Gold', code: '#C28E61' },
  { name: 'Wickerwork', code: '#C19E80' },
  { name: 'Crewel Tan', code: '#CBB99B' },
  { name: 'Empire Gold', code: '#C19F6E' },
  { name: 'Majolica Green', code: '#AEB08F' },
  { name: 'Sheraton Sage', code: '#8F8666' },
  { name: 'Gallery Green', code: '#708672' },
  { name: 'Billiard Green', code: '#45584D' },
  { name: 'Calico', code: '#8CA49C' },
  { name: 'Teal Stencil', code: '#627F7B' },
  { name: 'Festoon Aqua', code: '#A0BBB8' },
  { name: 'Peacock Plume', code: '#739694' },
  { name: 'Queen Anne Lilac', code: '#C0B6B4' },
  { name: 'Patchwork Plum', code: '#7E696A' },
  { name: 'Pewter Tankard', code: '#A39B90' },
  { name: 'Curio Gray', code: '#988977' },
  { name: 'Rosedust', code: '#CC8D84' },
  { name: 'Rachel Pink', code: '#E8B9AE' },
  { name: 'Aristocrat Peach', code: '#ECCEB9' },
  { name: 'Caen Stone', code: '#ECD0B1' },
  { name: 'Acanthus', code: '#CDCDB4' },
  { name: 'Colonial Yellow', code: '#EFC488' },
  { name: 'Dutch Tile Blue', code: '#9AABAB' },
  { name: 'Needlepoint Navy', code: '#546670' },
  { name: 'Rembrandt Ruby', code: '#974F49' },
  { name: 'Roycroft Rose', code: '#C08F80' },
  { name: 'Warm Beige', code: '#EEDAC3' },
  { name: 'Buckram Binding', code: '#D9C3A6' },
  { name: 'Morris Room Grey', code: '#ADA193' },
  { name: 'Library Pewter', code: '#7F7263' },
  { name: 'Mellow Mauve', code: '#C4957A' },
  { name: 'Roycroft Adobe', code: '#A76251' },
  { name: 'Dard Hunter Green', code: '#3A4A3F' },
  { name: 'Ruskin Room Green', code: '#ACA17D' },
  { name: 'Peristyle Brass', code: '#AE905E' },
  { name: 'Hubbard Squash', code: '#E9BF8C' },
  { name: 'Antiquarian Brown', code: '#946644' },
  { name: 'White Hyacinth', code: '#F3E5D1' },
  { name: 'Studio Blue Green', code: '#6D817B' },
  { name: 'Bunglehouse Blue', code: '#47626F' },
  { name: 'Silver Gray', code: '#B8B2A2' },
  { name: 'Classic Light Buff', code: '#F0EADC' },
  { name: 'Classic Ivory', code: '#F2E0C3' },
  { name: 'Pearl Gray', code: '#CBCEC5' },
  { name: 'Porcelain', code: '#E9E0D5' },
  { name: 'Twilight Gray', code: '#C8BFB5' },
  { name: 'Light French Gray', code: '#C2C0BB' },
  { name: 'Classic Sand', code: '#D6BCAA' },
  { name: 'Chinese Red', code: '#9E3E33' },
  { name: 'Jazz Age Coral', code: '#F1BFB1' },
  { name: 'Frostwork', code: '#CBD0C2' },
  { name: 'Alexandrite', code: '#598C74' },
  { name: 'Salon Rose', code: '#AB7878' },
  { name: 'Studio Mauve', code: '#C6B9B8' },
  { name: 'Blue Sky', code: '#ABD1C9' },
  { name: 'Blue Peacock', code: '#014E4C' },
  { name: 'Vogue Green', code: '#4B5645' },
  { name: 'Cascade Green', code: '#ACB19F' },
  { name: 'Belvedere Cream', code: '#F0CDA0' },
  { name: 'Copen Blue', code: '#C2CCC4' },
  { name: 'Rose Tan', code: '#CD9C85' },
  { name: 'Pink Shadow', code: '#DEC3B9' },
  { name: 'Orchid', code: '#BC9C9E' },
  { name: 'Deep Maroon', code: '#623F45' },
  { name: 'Chartreuse', code: '#E1D286' },
  { name: 'Radiant Lilac', code: '#A489A0' },
  { name: 'Holiday Turquoise', code: '#8AC6BD' },
  { name: 'Appleblossom', code: '#DAB5B4' },
  { name: 'Classic French Gray', code: '#888782' },
  { name: 'Sunbeam Yellow', code: '#F0D39D' },
  { name: 'Pinky Beige', code: '#C9AA98' },
  { name: 'Pink Flamingo', code: '#CD717B' },
  { name: 'Skyline Steel', code: '#C6BFB3' },
  { name: 'Venetian Yellow', code: '#F6E3A1' },
  { name: 'Icy Lemonade', code: '#F4E8B2' },
  { name: 'Pineapple Cream', code: '#F2EAC3' },
  { name: 'Merlot', code: '#51323B' },
  { name: 'Rockweed', code: '#443735' },
  { name: 'Charcoal Blue', code: '#3D4450' },
  { name: 'Mineral Gray', code: '#515763' },
  { name: 'Rookwood Dark Red', code: '#4B2929' },
  { name: 'Rookwood Red', code: '#622F2D' },
  { name: 'Rookwood Terra Cotta', code: '#975840' },
  { name: 'Renwick Rose Beige', code: '#AF8871' },
  { name: 'Renwick Beige', code: '#C3B09D' },
  { name: 'Rookwood Brown', code: '#7F614A' },
  { name: 'Rookwood Medium Brown', code: '#6E5241' },
  { name: 'Rookwood Dark Brown', code: '#5F4D43' },
  { name: 'Rookwood Shutter Green', code: '#303B39' },
  { name: 'Rookwood Sash Green', code: '#506A67' },
  { name: 'Rookwood Blue Green', code: '#738478' },
  { name: 'Rookwood Jade', code: '#979F7F' },
  { name: 'Downing Straw', code: '#CAAB7D' },
  { name: 'Rookwood Antique Gold', code: '#A58258' },
  { name: 'Renwick Olive', code: '#97896A' },
  { name: 'Rookwood Dark Green', code: '#565C4A' },
  { name: 'Rookwood Amber', code: '#C08650' },
  { name: 'Renwick Heather', code: '#8B7D7B' },
  { name: 'Downing Slate', code: '#777F86' },
  { name: 'Downing Earth', code: '#887B67' },
  { name: 'Downing Stone', code: '#A6A397' },
  { name: 'Downing Sand', code: '#CBBCA5' },
  { name: 'Rookwood Clay', code: '#9A7E64' },
  { name: 'Renwick Golden Oak', code: '#96724C' },
  { name: 'Colonial Revival Green Stone', code: '#A39B7E' },
  { name: 'Colonial Revival Stone', code: '#A7947C' },
  { name: 'Colonial Revival Tan', code: '#D3B699' },
  { name: 'Classical White', code: '#ECE1CB' },
  { name: 'Classical Gold', code: '#EBB875' },
  { name: 'Colonial Revival Gray', code: '#B4B9B9' },
  { name: 'Roycroft Vellum', code: '#E8D9BD' },
  { name: 'Birdseye Maple', code: '#E4C495' },
  { name: 'Craftsman Brown', code: '#AE9278' },
  { name: 'Quartersawn Oak', code: '#85695B' },
  { name: 'Aurora Brown', code: '#6A4238' },
  { name: 'Polished Mahogany', code: '#432722' },
  { name: 'Roycroft Copper Red', code: '#7B3728' },
  { name: 'Hammered Silver', code: '#978A7F' },
  { name: 'Weathered Shingle', code: '#937F68' },
  { name: 'Roycroft Suede', code: '#A79473' },
  { name: 'Roycroft Brass', code: '#7A6A51' },
  { name: 'Roycroft Mist Gray', code: '#C2BDB1' },
  { name: 'Bunglehouse Gray', code: '#988F7B' },
  { name: 'Roycroft Bronze Green', code: '#575449' },
  { name: 'Roycroft Bottle Green', code: '#324038' },
  { name: 'Roycroft Pewter', code: '#616564' },
  { name: 'Westchester Gray', code: '#797978' },
  { name: 'Chelsea Gray', code: '#B6B7B0' },
  { name: 'Sage Green Light', code: '#73705E' },
  { name: 'New Colonial Yellow', code: '#D9AD7F' },
  { name: 'Caribbean Coral', code: '#BE795E' },
  { name: 'Sycamore Tan', code: '#9C8A79' },
  { name: 'Fairfax Brown', code: '#61463A' },
  { name: 'Peace Yellow', code: '#EECF9E' },
  { name: 'Harvest Gold', code: '#D9A06A' },
  { name: 'Beige', code: '#DFC8B5' },
  { name: 'Sage', code: '#B3AE95' },
  { name: 'Avocado', code: '#857C5D' },
  { name: 'Powder Blue', code: '#89A4AD' },
  { name: 'Classical Yellow', code: '#F8D492' },
  { name: 'Snowfall', code: '#E0DEDA' },
  { name: 'Grayish', code: '#CFCAC7' },
  { name: 'Essential Gray', code: '#BCB8B6' },
  { name: 'Proper Gray', code: '#ADA8A5' },
  { name: 'Mink', code: '#847B77' },
  { name: 'Folkstone', code: '#6D6562' },
  { name: 'Black Bean', code: '#403330' },
  { name: 'Smart White', code: '#E4DBD8' },
  { name: 'Individual White', code: '#D4CDCA' },
  { name: 'Imagine', code: '#C2B6B6' },
  { name: 'Flexible Gray', code: '#B1A3A1' },
  { name: 'Chinchilla', code: '#867875' },
  { name: 'Browse Brown', code: '#6E615F' },
  { name: 'Bitter Chocolate', code: '#4D3C3C' },
  { name: 'Vaguely Mauve', code: '#D1C5C4' },
  { name: 'Chaise Mauve', code: '#C1B2B3' },
  { name: 'Intuitive', code: '#B3A3A5' },
  { name: 'Enigma', code: '#8B7C7E' },
  { name: 'Poetry Plum', code: '#6F5C5F' },
  { name: 'Marooned', code: '#4E3132' },
  { name: 'Dreamy White', code: '#E3D9D5' },
  { name: 'Breathless', code: '#D6C2BE' },
  { name: 'Insightful Rose', code: '#C9B0AB' },
  { name: 'Dressy Rose', code: '#B89D9A' },
  { name: 'Socialite', code: '#907676' },
  { name: 'River Rouge', code: '#76595D' },
  { name: 'Cordovan', code: '#5F3D3F' },
  { name: 'Cultured Pearl', code: '#E5DCD6' },
  { name: 'White Truffle', code: '#D7C8C2' },
  { name: 'Artistic Taupe', code: '#C3B1AC' },
  { name: 'Glamour', code: '#B6A09A' },
  { name: 'Dutch Cocoa', code: '#8C706A' },
  { name: 'Bateau Brown', code: '#7A5F5A' },
  { name: 'Dark Auburn', code: '#5A3532' },
  { name: 'Gauzy White', code: '#E3DBD4' },
  { name: 'Angora', code: '#D1C5BE' },
  { name: 'Temperate Taupe', code: '#BFB1AA' },
  { name: 'Truly Taupe', code: '#AC9E97' },
  { name: 'Poised Taupe', code: '#8C7E78' },
  { name: 'Nutshell', code: '#756761' },
  { name: 'Otter', code: '#56433B' },
  { name: 'Hush White', code: '#E5DAD4' },
  { name: 'Unfussy Beige', code: '#D6C8C0' },
  { name: 'Doeskin', code: '#C6B3A9' },
  { name: 'Emerging Taupe', code: '#B8A196' },
  { name: 'Swing Brown', code: '#947569' },
  { name: 'Hot Cocoa', code: '#806257' },
  { name: 'Terra Brun', code: '#5A382D' },
  { name: 'Gorgeous White', code: '#E7DBD3' },
  { name: 'Abalone Shell', code: '#DBC7BD' },
  { name: 'Sashay Sand', code: '#CFB4A8' },
  { name: 'Sandbank', code: '#C3A497' },
  { name: 'Reddened Earth', code: '#9C6E63' },
  { name: 'Canyon Clay', code: '#85594F' },
  { name: 'Fiery Brown', code: '#5D3831' },
  { name: 'Polite White', code: '#E9DDD4' },
  { name: 'Malted Milk', code: '#DECABD' },
  { name: 'Likeable Sand', code: '#D1B7A8' },
  { name: 'Interface Tan', code: '#C1A392' },
  { name: 'Moroccan Spice', code: '#9D7868' },
  { name: 'Tanbark', code: '#896656' },
  { name: 'Vintage Leather', code: '#694336' },
  { name: 'Nice White', code: '#E6DDD5' },
  { name: 'Reticence', code: '#D9CDC3' },
  { name: 'Bona Fide Beige', code: '#CBB9AB' },
  { name: 'Sand Trap', code: '#BBA595' },
  { name: 'Mocha', code: '#967A6A' },
  { name: 'Brevity Brown', code: '#715243' },
  { name: 'French Roast', code: '#4F3426' },
  { name: 'Heron Plume', code: '#E5E1D8' },
  { name: 'Popular Gray', code: '#D4CCC3' },
  { name: 'Versatile Gray', code: '#C1B6AB' },
  { name: 'Perfect Greige', code: '#B7AB9F' },
  { name: 'Spalding Gray', code: '#8D7F75' },
  { name: 'Garret Gray', code: '#756861' },
  { name: 'Turkish Coffee', code: '#4D3930' },
  { name: 'Everyday White', code: '#E4DCD4' },
  { name: 'Realist Beige', code: '#D3C8BD' },
  { name: 'Diverse Beige', code: '#C2B4A7' },
  { name: 'Utterly Beige', code: '#B5A597' },
  { name: 'Down Home', code: '#907865' },
  { name: 'Cobble Brown', code: '#7A6455' },
  { name: 'Sable', code: '#5F4B3F' },
  { name: 'Modest White', code: '#E6DDD4' },
  { name: 'Simplify Beige', code: '#D6C7B9' },
  { name: 'Sand Dune', code: '#C5B1A2' },
  { name: 'Trusty Tan', code: '#B59F8F' },
  { name: 'Nuthatch', code: '#8E725F' },
  { name: 'Grounded', code: '#785B47' },
  { name: 'Java', code: '#634533' },
  { name: 'Reliable White', code: '#E8DED3' },
  { name: 'Lightweight Beige', code: '#DAC8B8' },
  { name: 'Familiar Beige', code: '#CAB3A0' },
  { name: 'Sensational Sand', code: '#BFA38D' },
  { name: 'Toasty', code: '#957258' },
  { name: 'Jute Brown', code: '#815D40' },
  { name: 'Sturdy Brown', code: '#69482C' },
  { name: 'Pacer White', code: '#E5DDD0' },
  { name: 'Sand Dollar', code: '#D7C5B3' },
  { name: 'Practical Beige', code: '#C9B29C' },
  { name: 'Sands of Time', code: '#BCA38B' },
  { name: 'Portabello', code: '#947A62' },
  { name: 'Tea Chest', code: '#7D644D' },
  { name: 'Kaffee', code: '#65503D' },
  { name: 'Divine White', code: '#E6DCCD' },
  { name: 'Kilim Beige', code: '#D7C5AE' },
  { name: 'Nomadic Desert', code: '#C7B198' },
  { name: 'Latte', code: '#BAA185' },
  { name: 'Hopsack', code: '#9E8163' },
  { name: 'Steady Brown', code: '#8A6B4D' },
  { name: 'Coconut Husk', code: '#70573F' },
  { name: 'Biscuit', code: '#EBDDCB' },
  { name: 'Interactive Cream', code: '#E4CAAD' },
  { name: 'Bagel', code: '#D7B593' },
  { name: 'Totally Tan', code: '#CCA683' },
  { name: 'Tatami Tan', code: '#BA8C64' },
  { name: 'Smokey Topaz', code: '#A57955' },
  { name: 'Leather Bound', code: '#8D623D' },
  { name: 'Antique White', code: '#E8DCC6' },
  { name: 'Believable Buff', code: '#DBC7A8' },
  { name: 'Whole Wheat', code: '#CDB592' },
  { name: 'Camelback', code: '#C5AA85' },
  { name: 'Baguette', code: '#B39167' },
  { name: 'Cardboard', code: '#9C7A56' },
  { name: 'Craft Paper', code: '#8A6645' },
  { name: 'Navajo White', code: '#E9DCC6' },
  { name: 'Ivoire', code: '#E4CEAC' },
  { name: 'Blonde', code: '#DCBD92' },
  { name: 'Restrained Gold', code: '#D2B084' },
  { name: 'Mannered Gold', code: '#C19763' },
  { name: 'Chamois', code: '#AD8451' },
  { name: 'Relic Bronze', code: '#906A3A' },
  { name: 'Muslin', code: '#EADFC9' },
  { name: 'Netsuke', code: '#E0CFB0' },
  { name: 'Ecru', code: '#D0BA94' },
  { name: 'Harmonic Tan', code: '#C6B08A' },
  { name: 'Burlap', code: '#AC9571' },
  { name: 'Artifact', code: '#9A815E' },
  { name: 'Mossy Gold', code: '#7F6743' },
  { name: 'Moderate White', code: '#E9DECF' },
  { name: 'Softer Tan', code: '#DACAB2' },
  { name: 'Macadamia', code: '#CCB79B' },
  { name: 'Basket Beige', code: '#C0A98B' },
  { name: 'Dapper Tan', code: '#947F65' },
  { name: 'Thatch Brown', code: '#867057' },
  { name: 'Umber', code: '#6E543C' },
  { name: 'Panda White', code: '#EAE2D4' },
  { name: 'Wool Skein', code: '#D9CFBA' },
  { name: 'Relaxed Khaki', code: '#C8BBA3' },
  { name: 'Universal Khaki', code: '#B8A992' },
  { name: 'Quiver Tan', code: '#8E7F6A' },
  { name: 'Superior Bronze', code: '#786957' },
  { name: 'Protégé Bronze', code: '#66543E' },
  { name: 'Nacre', code: '#E8E2D4' },
  { name: 'Rice Grain', code: '#DBD0B9' },
  { name: 'Ramie', code: '#CDBDA2' },
  { name: 'Favorite Tan', code: '#C1AE91' },
  { name: 'Sawdust', code: '#998970' },
  { name: 'High Tea', code: '#7E6F59' },
  { name: 'Best Bronze', code: '#5D513E' },
  { name: 'Nonchalant White', code: '#DEDDD1' },
  { name: 'Ancient Marble', code: '#D1CCB9' },
  { name: 'Grassland', code: '#C1BCA7' },
  { name: 'Svelte Sage', code: '#B2AC96' },
  { name: 'Connected Gray', code: '#898473' },
  { name: 'Eclipse', code: '#6B6757' },
  { name: 'Garden Gate', code: '#5E5949' },
  { name: 'Moderne White', code: '#E2E0D7' },
  { name: 'Sedate Gray', code: '#D1CDBF' },
  { name: 'Techno Gray', code: '#BFB9AA' },
  { name: 'Chatroom', code: '#B0AB9C' },
  { name: 'Hardware', code: '#8B8372' },
  { name: 'Cocoon', code: '#726B5B' },
  { name: 'Andiron', code: '#424036' },
  { name: 'Sagey', code: '#E2E2D1' },
  { name: 'Liveable Green', code: '#CECEBD' },
  { name: 'Softened Green', code: '#BBBCA7' },
  { name: 'Clary Sage', code: '#ACAD97' },
  { name: 'Artichoke', code: '#7F8266' },
  { name: 'Oakmoss', code: '#65684C' },
  { name: 'Secret Garden', code: '#4F523A' },
  { name: 'Ethereal White', code: '#E3E2D9' },
  { name: 'Conservative Gray', code: '#D1D0C6' },
  { name: 'Austere Gray', code: '#BEBFB2' },
  { name: 'Escape Gray', code: '#ABAC9F' },
  { name: 'Dried Thyme', code: '#7B8070' },
  { name: 'Rosemary', code: '#64695C' },
  { name: 'Shade-Grown', code: '#4E5147' },
  { name: 'Opaline', code: '#DCDFD7' },
  { name: 'Filmy Green', code: '#D1D3C7' },
  { name: 'Contented', code: '#BDC0B3' },
  { name: 'Coastal Plain', code: '#9FA694' },
  { name: 'Privilege Green', code: '#7A8775' },
  { name: 'Basil', code: '#626E60' },
  { name: 'Rock Garden', code: '#465448' },
  { name: 'Frosty White', code: '#DDDDD6' },
  { name: 'Aloof Gray', code: '#C9C9C0' },
  { name: 'Sensible Hue', code: '#B6B5AB' },
  { name: 'Rare Gray', code: '#A6A69B' },
  { name: 'Link Gray', code: '#7F7E72' },
  { name: 'Thunderous', code: '#6D6C62' },
  { name: 'Cast Iron', code: '#64645A' },
  { name: 'Spare White', code: '#E4E4DD' },
  { name: 'Sea Salt', code: '#CDD2CA' },
  { name: 'Comfort Gray', code: '#BEC3BB' },
  { name: 'Oyster Bay', code: '#AEB3A9' },
  { name: 'Retreat', code: '#7A8076' },
  { name: 'Pewter Green', code: '#5E6259' },
  { name: 'Ripe Olive', code: '#44483D' },
  { name: 'Window Pane', code: '#D7DFD8' },
  { name: 'Rainwashed', code: '#C2CDC5' },
  { name: 'Quietude', code: '#ADBBB2' },
  { name: 'Halcyon Green', code: '#9BAAA2' },
  { name: 'Underseas', code: '#7C8E87' },
  { name: 'Rocky River', code: '#5E706A' },
  { name: 'Jasper', code: '#343B36' },
  { name: 'Topsail', code: '#DAE2E0' },
  { name: 'Tradewind', code: '#C2CFCF' },
  { name: 'Rain', code: '#ABBEBF' },
  { name: 'Interesting Aqua', code: '#9BAFB2' },
  { name: 'Moody Blue', code: '#7A9192' },
  { name: 'Riverway', code: '#5D7274' },
  { name: 'Still Water', code: '#4A5D5F' },
  { name: 'Mountain Air', code: '#D8E0DF' },
  { name: 'Sleepy Blue', code: '#BCCBCE' },
  { name: 'Languid Blue', code: '#A4B7BD' },
  { name: 'Meditative', code: '#96AAB0' },
  { name: 'Refuge', code: '#607D84' },
  { name: 'Tempe Star', code: '#47626A' },
  { name: 'Rainstorm', code: '#244653' },
  { name: 'Rock Candy', code: '#DEE1DF' },
  { name: 'Misty', code: '#CDD2D2' },
  { name: 'Samovar Silver', code: '#B8BEBE' },
  { name: 'Uncertain Gray', code: '#A9B0B1' },
  { name: 'Foggy Day', code: '#727C7F' },
  { name: 'Grays Harbor', code: '#596368' },
  { name: 'Dark Night', code: '#23383F' },
  { name: 'Iceberg', code: '#DBDFE0' },
  { name: 'Upward', code: '#BFC9D0' },
  { name: 'Windy Blue', code: '#AABAC6' },
  { name: 'Aleutian', code: '#98A9B7' },
  { name: 'Bracing Blue', code: '#768B9A' },
  { name: 'Distance', code: '#5D6F7F' },
  { name: 'Naval', code: '#2F3D4C' },
  { name: 'Quicksilver', code: '#DDE2E0' },
  { name: 'North Star', code: '#CAD0D2' },
  { name: 'Krypton', code: '#B8C0C3' },
  { name: 'Jubilee', code: '#ADB5B9' },
  { name: 'Storm Cloud', code: '#7A848D' },
  { name: 'Granite Peak', code: '#606B75' },
  { name: 'Outerspace', code: '#586168' },
  { name: 'Ice Cube', code: '#E3E4E1' },
  { name: 'Olympus White', code: '#D4D8D7' },
  { name: 'Lazy Gray', code: '#BEC1C3' },
  { name: 'Morning Fog', code: '#A8AEB1' },
  { name: 'Serious Gray', code: '#7D848B' },
  { name: 'Gibraltar', code: '#626970' },
  { name: 'Tricorn Black', code: '#2F2F30' },
  { name: 'Spatial White', code: '#DDDCDB' },
  { name: 'Unique Gray', code: '#CBC9C9' },
  { name: 'Swanky Gray', code: '#B5B1B5' },
  { name: 'Mysterious Mauve', code: '#A6A3A9' },
  { name: 'Exclusive Plum', code: '#736F78' },
  { name: 'Midnight', code: '#5D5962' },
  { name: 'Quixotic Plum', code: '#4A4653' },
  { name: 'Sensitive Tint', code: '#CEC9CC' },
  { name: 'Veiled Violet', code: '#BDB5B9' },
  { name: 'Beguiling Mauve', code: '#AFA7AC' },
  { name: 'Soulmate', code: '#85777B' },
  { name: 'Expressive Plum', code: '#695C62' },
  { name: 'Plum Brown', code: '#4E4247' },
  { name: 'Destiny', code: '#CFC9C8' },
  { name: 'Fashionable Gray', code: '#BDB8B8' },
  { name: 'Mystical Shade', code: '#AEA9AA' },
  { name: 'Special Gray', code: '#7B787D' },
  { name: 'Cloak Gray', code: '#605E63' },
  { name: 'Black Swan', code: '#3A373E' },
  { name: 'Wallflower', code: '#DBCFD4' },
  { name: 'Mauve Finery', code: '#CBB8C0' },
  { name: 'Thistle', code: '#AA8E9A' },
  { name: 'Plum Dandy', code: '#8B6878' },
  { name: 'Grape Harvest', code: '#7E5A6D' },
  { name: 'Mature Grape', code: '#5F3F54' },
  { name: 'Rosebud', code: '#E0CDD1' },
  { name: 'Delightful', code: '#D2B6BE' },
  { name: 'Rosé', code: '#B995A1' },
  { name: 'Moss Rose', code: '#9E6D79' },
  { name: 'Berry Bush', code: '#8D5869' },
  { name: 'Fabulous Grape', code: '#6D344F' },
  { name: 'Demure', code: '#E8D4D5' },
  { name: 'Fading Rose', code: '#DABDC1' },
  { name: 'Rose Embroidery', code: '#C79EA2' },
  { name: 'Concerto', code: '#9E6B75' },
  { name: 'Aged Wine', code: '#895460' },
  { name: 'Burgundy', code: '#63333E' },
  { name: 'Innocence', code: '#EBD1CF' },
  { name: 'Rose Colored', code: '#DCB6B5' },
  { name: 'Pressed Flower', code: '#C39393' },
  { name: 'Rambling Rose', code: '#995D62' },
  { name: 'Cordial', code: '#864C52' },
  { name: 'Fine Wine', code: '#723941' },
  { name: 'Charming Pink', code: '#EDD3D2' },
  { name: 'Lotus Flower', code: '#E6BDBD' },
  { name: 'Memorable Rose', code: '#CF8A8D' },
  { name: 'Redbud', code: '#AD5E65' },
  { name: 'Kirsch Red', code: '#974953' },
  { name: 'Luxurious Red', code: '#863A42' },
  { name: 'Rosy Outlook', code: '#EBCECB' },
  { name: 'Gracious Rose', code: '#E3B7B1' },
  { name: 'Resounding Rose', code: '#CD8E89' },
  { name: 'Reddish', code: '#B56966' },
  { name: 'Bravado Red', code: '#A0524E' },
  { name: 'Red Bay', code: '#8E3738' },
  { name: 'Intimate White', code: '#F0E1D8' },
  { name: 'Romance', code: '#EBCFC3' },
  { name: 'Mellow Coral', code: '#E3B5A8' },
  { name: 'Constant Coral', code: '#CD8E7F' },
  { name: 'Henna Shade', code: '#B3675D' },
  { name: 'Bold Brick', code: '#A0584F' },
  { name: 'Fireweed', code: '#7B3730' },
  { name: 'Faint Coral', code: '#EEDED5' },
  { name: 'Quaint Peche', code: '#EACDC1' },
  { name: 'Smoky Salmon', code: '#E2B6A7' },
  { name: 'Coral Island', code: '#CE9382' },
  { name: 'Foxy', code: '#A85E53' },
  { name: 'Flower Pot', code: '#8F4438' },
  { name: 'Fired Brick', code: '#83382A' },
  { name: 'Nearly Peach', code: '#EFDED1' },
  { name: 'Spun Sugar', code: '#EDD2C0' },
  { name: 'Warming Peach', code: '#E4B9A2' },
  { name: 'Persimmon', code: '#D9987C' },
  { name: 'Baked Clay', code: '#C1785C' },
  { name: 'Red Cent', code: '#AD654C' },
  { name: 'Spicy Hue', code: '#994B35' },
  { name: 'Alluring White', code: '#EFE1D2' },
  { name: 'Peach Fuzz', code: '#ECCFBB' },
  { name: 'Sumptuous Peach', code: '#E5B99B' },
  { name: 'Fame Orange', code: '#DB9C7B' },
  { name: 'Chrysanthemum', code: '#C47B5B' },
  { name: 'Reynard', code: '#B46848' },
  { name: 'Pennywise', code: '#A2583A' },
  { name: 'Intricate Ivory', code: '#EDDDCA' },
  { name: 'Sweet Orange', code: '#EBCCB3' },
  { name: 'Soft Apricot', code: '#E0B392' },
  { name: 'Chivalry Copper', code: '#D4966E' },
  { name: 'Armagnac', code: '#C38058' },
  { name: 'Truepenny', code: '#B46C42' },
  { name: 'Copper Mountain', code: '#A6613C' },
  { name: 'Choice Cream', code: '#F0E1D0' },
  { name: 'Creamery', code: '#EDD0B6' },
  { name: 'Sociable', code: '#E8BE9B' },
  { name: 'Folksy Gold', code: '#D69969' },
  { name: 'Autumnal', code: '#CD8C5D' },
  { name: 'Tigereye', code: '#BB7748' },
  { name: 'Gingery', code: '#B06C3E' },
  { name: 'Eggwhite', code: '#F3E5D2' },
  { name: 'Cachet Cream', code: '#F3D9BA' },
  { name: 'Ambitious Amber', code: '#F0CB97' },
  { name: 'Viva Gold', code: '#E3AC72' },
  { name: 'Bakelite Gold', code: '#D7995D' },
  { name: 'Tassel', code: '#C6884A' },
  { name: 'Saucy Gold', code: '#B6743B' },
  { name: 'Vanillin', code: '#F2E3CA' },
  { name: 'Inviting Ivory', code: '#F2D5B0' },
  { name: 'Harvester', code: '#EDC38E' },
  { name: 'Torchlight', code: '#E5AE6B' },
  { name: 'Honeycomb', code: '#D59858' },
  { name: 'Gold Coast', code: '#C78538' },
  { name: 'Butterscotch', code: '#B67D3C' },
  { name: 'Crisp Linen', code: '#F3E6D4' },
  { name: 'Jersey Cream', code: '#F5DEBB' },
  { name: 'Humble Gold', code: '#EDC796' },
  { name: 'Anjou Pear', code: '#DDAC6D' },
  { name: 'Ceremonial Gold', code: '#D69E59' },
  { name: 'Golden Rule', code: '#CC9249' },
  { name: 'Cut the Mustard', code: '#BA7F38' },
  { name: 'Dover White', code: '#F0EADC' },
  { name: 'Napery', code: '#EFDDC1' },
  { name: 'Compatible Cream', code: '#E8C89E' },
  { name: 'Golden Fleece', code: '#D6AD78' },
  { name: 'Butternut', code: '#CC9B5C' },
  { name: 'Bosc Pear', code: '#C09056' },
  { name: 'Gallant Gold', code: '#A4763C' },
  { name: 'Vital Yellow', code: '#EDE0C5' },
  { name: 'Convivial Yellow', code: '#E9D6B0' },
  { name: 'Sequin', code: '#E1C28D' },
  { name: 'Alchemy', code: '#C99E53' },
  { name: 'Different Gold', code: '#BC934D' },
  { name: 'Nankeen', code: '#AA803A' },
  { name: 'Sconce Gold', code: '#996F32' },
  { name: 'Chamomile', code: '#E9E0C5' },
  { name: 'Lucent Yellow', code: '#E4D0A5' },
  { name: 'Independent Gold', code: '#D2BA83' },
  { name: 'Antiquity', code: '#C2A462' },
  { name: 'Escapade Gold', code: '#B89B59' },
  { name: 'Grandiose', code: '#9C7F41' },
  { name: 'Fervent Brass', code: '#95793D' },
  { name: 'Ionic Ivory', code: '#E7DFC5' },
  { name: 'Ancestral Gold', code: '#DDCDA6' },
  { name: 'Wheat Grass', code: '#CBB584' },
  { name: 'Edgy Gold', code: '#B1975F' },
  { name: 'Brassy', code: '#9D8344' },
  { name: 'Bengal Grass', code: '#8E773F' },
  { name: 'Eminent Bronze', code: '#7A6841' },
  { name: 'Restoration Ivory', code: '#E9E1CA' },
  { name: 'Rice Paddy', code: '#DFD4B0' },
  { name: 'Hearts of Palm', code: '#CFC291' },
  { name: 'Sassy Green', code: '#BBA86A' },
  { name: 'Tupelo Tree', code: '#9C9152' },
  { name: 'Rural Green', code: '#8D844D' },
  { name: 'Saguaro', code: '#655F2D' },
  { name: "Queen Anne's Lace", code: '#ECEAD5' },
  { name: 'Celery', code: '#E0DDBD' },
  { name: 'Shagreen', code: '#CBC99D' },
  { name: 'Ryegrass', code: '#AEAC7A' },
  { name: 'Tansy Green', code: '#95945C' },
  { name: 'Relentless Olive', code: '#71713E' },
  { name: 'Basque Green', code: '#5F6033' },
  { name: 'Sprout', code: '#E4E4CE' },
  { name: 'Honeydew', code: '#DBDDBD' },
  { name: 'Baize Green', code: '#C7CDA8' },
  { name: 'Great Green', code: '#ABB486' },
  { name: 'Leapfrog', code: '#88915D' },
  { name: 'Garden Spot', code: '#6D7645' },
  { name: 'Inverness', code: '#576238' },
  { name: 'Spinach White', code: '#E4E8DA' },
  { name: 'Gratifying Green', code: '#DAE2CD' },
  { name: 'Bonsai Tint', code: '#C5D1B2' },
  { name: 'Haven', code: '#A3B48C' },
  { name: 'Dill', code: '#788D60' },
  { name: 'Greenfield', code: '#60724F' },
  { name: 'Courtyard', code: '#475842' },
  { name: 'White Mint', code: '#E0E7DA' },
  { name: 'Supreme Green', code: '#CFDDC7' },
  { name: 'Relish', code: '#B3CBAA' },
  { name: 'Lounge Green', code: '#8BA97F' },
  { name: 'Garden Grove', code: '#5E7F57' },
  { name: 'Arugula', code: '#42603C' },
  { name: 'Evergreens', code: '#405840' },
  { name: 'Topiary Tint', code: '#C8D8C4' },
  { name: 'Easy Green', code: '#ACC2A8' },
  { name: 'Nurture Green', code: '#98B092' },
  { name: 'Inland', code: '#6C8867' },
  { name: 'Cilantro', code: '#537150' },
  { name: 'Shamrock', code: '#205134' },
  { name: 'Fleeting Green', code: '#D8E2D8' },
  { name: 'Slow Green', code: '#C6D5C9' },
  { name: 'Kind Green', code: '#AAC2B3' },
  { name: 'Restful', code: '#91AF9D' },
  { name: 'Jadite', code: '#61826C' },
  { name: 'Kale Green', code: '#4F6A56' },
  { name: 'Isle of Pines', code: '#3D5541' },
  { name: 'Green Trance', code: '#D7E4DB' },
  { name: 'Breaktime', code: '#C4D9CE' },
  { name: 'Aloe', code: '#ACCABC' },
  { name: 'Spearmint', code: '#94B5A6' },
  { name: 'Grandview', code: '#6B927F' },
  { name: 'Kendal Green', code: '#547867' },
  { name: 'Hunt Club', code: '#2A4F43' },
  { name: 'Waterscape', code: '#BFD2C9' },
  { name: 'Hazel', code: '#A8C1B7' },
  { name: 'Composed', code: '#7EA298' },
  { name: 'Surf Green', code: '#5F887D' },
  { name: 'Raging Sea', code: '#476F65' },
  { name: 'Country Squire', code: '#124A42' },
  { name: 'Glimmer', code: '#E0E7E2' },
  { name: 'Tidewater', code: '#C3D7D3' },
  { name: 'Watery', code: '#B4CCC9' },
  { name: 'Drizzle', code: '#8CAEAB' },
  { name: 'Lagoon', code: '#518682' },
  { name: 'Green Bay', code: '#2E6864' },
  { name: 'Cape Verde', code: '#01554F' },
  { name: 'Meander Blue', code: '#BEDBD8' },
  { name: 'Raindrop', code: '#9EC6C6' },
  { name: 'Reflecting Pool', code: '#7BB1B2' },
  { name: 'Cloudburst', code: '#5C9598' },
  { name: 'Grand Canal', code: '#3C797D' },
  { name: 'Really Teal', code: '#016367' },
  { name: 'Open Air', code: '#C7DFE0' },
  { name: 'Jetstream', code: '#B0D2D6' },
  { name: 'Ebbtide', code: '#84B4BE' },
  { name: 'Lakeshore', code: '#5B96A2' },
  { name: 'Great Falls', code: '#217786' },
  { name: 'Oceanside', code: '#015A6B' },
  { name: 'Blue Horizon', code: '#D8E7E6' },
  { name: 'Byte Blue', code: '#C5DCE0' },
  { name: 'Stream', code: '#ADCCD3' },
  { name: 'Open Seas', code: '#83AFBC' },
  { name: 'Manitou Blue', code: '#5B92A2' },
  { name: 'Loch Blue', code: '#2F778B' },
  { name: 'Bosporus', code: '#015D75' },
  { name: 'Sky High', code: '#DCE7E8' },
  { name: 'Atmospheric', code: '#C2DAE0' },
  { name: 'Vast Sky', code: '#A9C9D7' },
  { name: 'Resolute Blue', code: '#85B0C4' },
  { name: 'Secure Blue', code: '#5389A1' },
  { name: 'Georgian Bay', code: '#22657F' },
  { name: 'Loyal Blue', code: '#01455E' },
  { name: 'Snowdrop', code: '#E0E8E7' },
  { name: 'Balmy', code: '#C5D8DE' },
  { name: 'Take Five', code: '#B3C9D3' },
  { name: 'Respite', code: '#97B4C3' },
  { name: 'Leisure Blue', code: '#6A8EA1' },
  { name: 'Down Pour', code: '#43718B' },
  { name: 'Regatta', code: '#215772' },
  { name: 'Hinting Blue', code: '#CED9DD' },
  { name: 'Honest Blue', code: '#B2C7D3' },
  { name: 'Notable Hue', code: '#8BA7BB' },
  { name: 'Sporty Blue', code: '#6A8AA4' },
  { name: 'Denim', code: '#506B84' },
  { name: 'Commodore', code: '#25476A' },
  { name: 'Rarified Air', code: '#E1E6E6' },
  { name: 'Icelandic', code: '#CBD8E1' },
  { name: 'Blissful Blue', code: '#B2C8D8' },
  { name: 'Cosmos', code: '#8EA9C2' },
  { name: 'Scanda', code: '#6B8CA9' },
  { name: 'Revel Blue', code: '#4C6B8A' },
  { name: 'Indigo', code: '#284A70' },
  { name: 'Mild Blue', code: '#CBD5DB' },
  { name: 'Icy', code: '#BBC7D2' },
  { name: 'Solitude', code: '#99A7B8' },
  { name: 'Searching Blue', code: '#6C7F9A' },
  { name: 'Luxe Blue', code: '#516582' },
  { name: 'Dignified', code: '#3B496D' },
  { name: 'Starry Night', code: '#D6D9DE' },
  { name: 'Daydream', code: '#BDC3CD' },
  { name: 'Vesper Violet', code: '#99A0B2' },
  { name: 'Soulful Blue', code: '#757C91' },
  { name: 'Mesmerize', code: '#5D657B' },
  { name: 'Majestic Purple', code: '#3B3C5A' },
  { name: 'Silver Peony', code: '#DAD6DB' },
  { name: 'Grape Mist', code: '#C5C0C9' },
  { name: 'Ash Violet', code: '#A29BAA' },
  { name: 'Mythical', code: '#7E778E' },
  { name: 'Purple Passage', code: '#645E77' },
  { name: 'Dewberry', code: '#3E385A' },
  { name: 'Lite Lavender', code: '#E0DADF' },
  { name: 'Enchant', code: '#D1C6D2' },
  { name: 'Obi Lilac', code: '#B0A3B6' },
  { name: 'Wood Violet', code: '#7A6B85' },
  { name: 'Plummy', code: '#675A75' },
  { name: 'Concord Grape', code: '#443757' },
  { name: 'Teaberry', code: '#EBD1DB' },
  { name: 'Irresistible', code: '#E3C0CF' },
  { name: 'Rosebay', code: '#CB9AAD' },
  { name: 'Red Clover', code: '#B87E93' },
  { name: 'Grandeur Plum', code: '#92576F' },
  { name: 'Framboise', code: '#7C3655' },
  { name: 'Lighthearted Pink', code: '#EDD5DD' },
  { name: 'Childlike', code: '#E8C0CF' },
  { name: 'Haute Pink', code: '#D899B1' },
  { name: 'Cyclamen', code: '#C47B95' },
  { name: 'Ruby Shade', code: '#A2566F' },
  { name: 'Juneberry', code: '#854158' },
  { name: 'Priscilla', code: '#F1D3DA' },
  { name: 'Azalea Flower', code: '#EFC0CB' },
  { name: 'Jaipur Pink', code: '#E392A1' },
  { name: 'Tuberose', code: '#D47C8C' },
  { name: 'Gala Pink', code: '#B04B63' },
  { name: 'Cerise', code: '#99324E' },
  { name: 'Impatiens Petal', code: '#F1D2D7' },
  { name: 'In the Pink', code: '#F0BCC9' },
  { name: 'Cheery', code: '#EB92A3' },
  { name: 'Coming up Roses', code: '#DD7788' },
  { name: 'Heartfelt', code: '#BD4C5F' },
  { name: 'Valentine', code: '#A53A4E' },
  { name: 'Alyssum', code: '#F2D5D7' },
  { name: 'Loveable', code: '#F0C1C6' },
  { name: 'Amaryllis', code: '#ED939D' },
  { name: 'Grenadine', code: '#D66972' },
  { name: 'Coral Bells', code: '#BB4B51' },
  { name: 'Poinsettia', code: '#9D373C' },
  { name: 'Bella Pink', code: '#F1C6C4' },
  { name: 'Hopeful', code: '#F0B3B2' },
  { name: 'Dishy Coral', code: '#ED9190' },
  { name: 'Begonia', code: '#D76C6E' },
  { name: 'Enticing Red', code: '#B74E4F' },
  { name: 'Tanager', code: '#A43834' },
  { name: 'Oleander', code: '#F2CCC5' },
  { name: 'Youthful Coral', code: '#F0AFA8' },
  { name: 'Charisma', code: '#EE9489' },
  { name: 'Coral Reef', code: '#D9766C' },
  { name: 'Red Tomato', code: '#B24743' },
  { name: 'Rave Red', code: '#A13B34' },
  { name: 'Koral Kicks', code: '#F2D1C3' },
  { name: 'Jovial', code: '#F2B8A7' },
  { name: 'Ravishing Coral', code: '#E79580' },
  { name: 'Lei Flower', code: '#D87B6A' },
  { name: 'Quite Coral', code: '#C76356' },
  { name: 'Peppery', code: '#B85444' },
  { name: 'Blushing', code: '#F0D1C3' },
  { name: 'Cosmetic Peach', code: '#F3C1AB' },
  { name: 'Sockeye', code: '#E49780' },
  { name: 'Rejuvenate', code: '#DD7861' },
  { name: 'Emotional', code: '#C65F47' },
  { name: 'Hearty Orange', code: '#B44B34' },
  { name: 'Peach Blossom', code: '#F3D0BD' },
  { name: 'Certain Peach', code: '#F2BDA2' },
  { name: 'Sunset', code: '#E2946F' },
  { name: 'Emberglow', code: '#D67C56' },
  { name: 'Robust Orange', code: '#C4633E' },
  { name: 'Jalapeño', code: '#B1533C' },
  { name: 'Naive Peach', code: '#F3D3BF' },
  { name: 'Neighborly Peach', code: '#F3C1A3' },
  { name: 'Inventive Orange', code: '#E89D6F' },
  { name: 'Copper Harbor', code: '#D57E52' },
  { name: 'Determined Orange', code: '#C56639' },
  { name: 'Husky Orange', code: '#BB613E' },
  { name: 'Flattering Peach', code: '#F4D3B3' },
  { name: 'Avid Apricot', code: '#F4C69F' },
  { name: 'Tangerine', code: '#F2AC78' },
  { name: 'Outgoing Orange', code: '#E6955F' },
  { name: 'Rhumba Orange', code: '#CB7841' },
  { name: 'Yam', code: '#C36F3E' },
  { name: 'Champagne', code: '#F2E3CE' },
  { name: 'Flan', code: '#F4D4AF' },
  { name: 'Delicious Melon', code: '#F5C894' },
  { name: 'Surprise Amber', code: '#EFB57A' },
  { name: 'Adventure Orange', code: '#E69F5F' },
  { name: 'Serape', code: '#D88B4D' },
  { name: 'Amber Wave', code: '#D28240' },
  { name: 'Welcome White', code: '#F3E3CA' },
  { name: 'Captivating Cream', code: '#F4D9B1' },
  { name: 'Honey Blush', code: '#F5CF9B' },
  { name: 'Papaya', code: '#EFB97B' },
  { name: 'Summer Day', code: '#EAAA62' },
  { name: 'Saffron Thread', code: '#DF984E' },
  { name: 'Marigold', code: '#D28233' },
  { name: 'Gardenia', code: '#F3E2C9' },
  { name: 'Enjoyable Yellow', code: '#F5D6A9' },
  { name: 'Afterglow', code: '#F6CD8E' },
  { name: 'Sunrise', code: '#F4BF77' },
  { name: 'Yarrow', code: '#EBAD5E' },
  { name: 'Gold Crest', code: '#DF9938' },
  { name: 'Curry', code: '#D88F32' },
  { name: 'Morning Sun', code: '#F3E6CE' },
  { name: 'Banana Cream', code: '#F5DEAF' },
  { name: 'Jonquil', code: '#F7D391' },
  { name: 'Afternoon', code: '#FBCB78' },
  { name: 'Butterfield', code: '#F7BE5B' },
  { name: 'Goldenrod', code: '#F2AF46' },
  { name: 'Sunflower', code: '#E39A33' },
  { name: 'Full Moon', code: '#F4E3BC' },
  { name: 'Friendly Yellow', code: '#F5E0B1' },
  { name: 'Butter Up', code: '#F6DDA3' },
  { name: 'June Day', code: '#F6C973' },
  { name: 'Bee', code: '#F1BA55' },
  { name: 'Brittlebush', code: '#EAAE47' },
  { name: 'Trinket', code: '#D69835' },
  { name: 'Lemon Chiffon', code: '#F5E5BC' },
  { name: 'Lantern Light', code: '#F4E1AE' },
  { name: 'Solaria', code: '#F5D68F' },
  { name: 'Overjoy', code: '#EEC25F' },
  { name: 'Gambol Gold', code: '#E1B047' },
  { name: 'Glitzy Gold', code: '#D6A02B' },
  { name: 'Auric', code: '#C48919' },
  { name: 'Lily', code: '#F3E8C2' },
  { name: 'Glad Yellow', code: '#F5E1AC' },
  { name: 'Midday', code: '#F7D78A' },
  { name: 'Quilt Gold', code: '#EAC365' },
  { name: 'Nugget', code: '#DBB04A' },
  { name: 'Kingdom Gold', code: '#D1A436' },
  { name: 'Crispy Gold', code: '#C49832' },
  { name: 'Daybreak', code: '#F3EAC6' },
  { name: 'Moonraker', code: '#EEE3B2' },
  { name: 'Lively Yellow', code: '#E6D88E' },
  { name: 'Frolic', code: '#D9C661' },
  { name: 'Hep Green', code: '#C4B146' },
  { name: 'High Strung', code: '#AC9825' },
  { name: 'Offbeat Green', code: '#9C8B1F' },
  { name: 'Springtime', code: '#E9E5B3' },
  { name: 'Gleeful', code: '#DAD790' },
  { name: 'Mélange Green', code: '#C4C476' },
  { name: 'Parakeet', code: '#B4B05A' },
  { name: 'Luau Green', code: '#989746' },
  { name: 'Verdant', code: '#847E35' },
  { name: 'Lime Granita', code: '#DCE1B8' },
  { name: 'Dancing Green', code: '#C5CD8F' },
  { name: 'Lime Rickey', code: '#AFB96A' },
  { name: 'Overt Green', code: '#97A554' },
  { name: 'Gecko', code: '#7A8833' },
  { name: 'Paradise', code: '#6C7B30' },
  { name: 'Cucumber', code: '#D3DFC3' },
  { name: 'Jardin', code: '#BDD0AB' },
  { name: 'Mesclun Green', code: '#9DB682' },
  { name: 'Pickle', code: '#85A16A' },
  { name: 'Talipot Palm', code: '#648149' },
  { name: 'Houseplant', code: '#58713F' },
  { name: 'Lacewing', code: '#E0E7DA' },
  { name: 'Romaine', code: '#B3CBAA' },
  { name: 'Picnic', code: '#99C285' },
  { name: 'Organic Green', code: '#7FAC6E' },
  { name: 'Grasshopper', code: '#4F854A' },
  { name: 'Espalier', code: '#2F5F3A' },
  { name: 'Jocular Green', code: '#CCE2CA' },
  { name: 'Kiwi', code: '#AED2B0' },
  { name: 'Vegan', code: '#8EC298' },
  { name: 'Eco Green', code: '#68A678' },
  { name: 'Kilkenny', code: '#498555' },
  { name: 'Derbyshire', code: '#245E36' },
  { name: 'Mint Condition', code: '#D1E3D2' },
  { name: 'Reclining Green', code: '#B7D7BF' },
  { name: 'Lark Green', code: '#8AC1A1' },
  { name: 'Julep', code: '#57AA80' },
  { name: 'Argyle', code: '#348A5D' },
  { name: 'Greens', code: '#016844' },
  { name: 'Embellished Blue', code: '#D7EBE2' },
  { name: 'Waterfall', code: '#C0E3DA' },
  { name: 'Refresh', code: '#A1D4C8' },
  { name: 'Larchmere', code: '#70BAA7' },
  { name: 'Jargon Jade', code: '#53A38F' },
  { name: 'Ionian', code: '#368976' },
  { name: 'Starboard', code: '#016C4F' },
  { name: 'Tame Teal', code: '#C1E6DF' },
  { name: 'Aqueduct', code: '#A1D5CB' },
  { name: 'Cooled Blue', code: '#75B9AE' },
  { name: 'Rivulet', code: '#61A89D' },
  { name: 'Thermal Spring', code: '#3B8C80' },
  { name: 'Poseidon', code: '#016D60' },
  { name: 'Swimming', code: '#C2E5E5' },
  { name: 'Spa', code: '#A7DCDC' },
  { name: 'Mariner', code: '#6EC2C4' },
  { name: 'Aquarium', code: '#3AA9AE' },
  { name: 'Gulfstream', code: '#01858B' },
  { name: 'Maxi Teal', code: '#017478' },
  { name: 'Bathe Blue', code: '#C2E0E3' },
  { name: 'Cay', code: '#A6D0D6' },
  { name: 'Rapture Blue', code: '#7DC1CB' },
  { name: 'Freshwater', code: '#4DA6B2' },
  { name: 'Briny', code: '#08808E' },
  { name: 'Blue Nile', code: '#01717E' },
  { name: 'Aviary Blue', code: '#C6E3E8' },
  { name: 'Liquid Blue', code: '#A6D4DE' },
  { name: 'Nautilus', code: '#71B8C7' },
  { name: 'Jamaica Bay', code: '#34A3B6' },
  { name: 'Cruising', code: '#018498' },
  { name: 'Amalfi', code: '#016E85' },
  { name: 'Bravo Blue', code: '#D3E7E9' },
  { name: 'Quench Blue', code: '#B4E0E7' },
  { name: 'Cloudless', code: '#8FD0DD' },
  { name: 'Fountain', code: '#56B5CA' },
  { name: 'Capri', code: '#01A0B8' },
  { name: 'Blue Mosque', code: '#01819E' },
  { name: 'Adriatic Sea', code: '#016081' },
  { name: 'Minor Blue', code: '#B7DFE8' },
  { name: 'Bluebell', code: '#A2D5E7' },
  { name: 'Flyway', code: '#5DB3D4' },
  { name: 'Major Blue', code: '#289EC4' },
  { name: 'Blue Plate', code: '#017CA7' },
  { name: 'Jay Blue', code: '#015D87' },
  { name: 'Iceberg', code: '#D6E4E7' },
  { name: 'Soar', code: '#C3DFE8' },
  { name: 'Something Blue', code: '#B0D6E6' },
  { name: 'Regale Blue', code: '#7DB5D3' },
  { name: 'Jacaranda', code: '#5A9EC0' },
  { name: 'Danube', code: '#2377A2' },
  { name: 'Dignity Blue', code: '#094C73' },
  { name: 'Rhythmic Blue', code: '#CCDBE5' },
  { name: 'Wondrous Blue', code: '#B8CDDD' },
  { name: 'Celestial', code: '#97B3D0' },
  { name: 'Lobelia', code: '#7498BE' },
  { name: 'Lupine', code: '#4E739F' },
  { name: 'Honorable Blue', code: '#164576' },
  { name: 'Wishful Blue', code: '#D8DDE6' },
  { name: 'Breathtaking', code: '#C7D1E2' },
  { name: 'Awesome Violet', code: '#A7B2D4' },
  { name: 'Dahlia', code: '#8B98C4' },
  { name: 'Gentian', code: '#6572A5' },
  { name: 'Valiant Violet', code: '#3E4371' },
  { name: 'Inspired Lilac', code: '#DFD9E4' },
  { name: 'Potentially Purple', code: '#D1CBDF' },
  { name: 'Wisteria', code: '#BDB4D4' },
  { name: 'Brave Purple', code: '#968DB8' },
  { name: 'Forget-Me-Not', code: '#716998' },
  { name: 'Izmir Purple', code: '#4D426E' },
  { name: 'Elation', code: '#DFDCE5' },
  { name: 'Rhapsody Lilac', code: '#D2C8DD' },
  { name: 'Magical', code: '#C0AFD0' },
  { name: 'Kismet', code: '#A18AB7' },
  { name: 'Clematis', code: '#7E6596' },
  { name: 'Impulsive Purple', code: '#624977' },
  { name: 'Spangle', code: '#E5DBE5' },
  { name: 'Euphoric Lilac', code: '#DAC7DA' },
  { name: 'Novel Lilac', code: '#C2A4C2' },
  { name: 'Baroness', code: '#A785A7' },
  { name: 'Vigorous Violet', code: '#7C5A7E' },
  { name: 'Kimono Violet', code: '#5D395F' },
  { name: 'Exuberant Pink', code: '#B54D7F' },
  { name: 'Dynamo', code: '#953D68' },
  { name: 'Forward Fuchsia', code: '#92345B' },
  { name: 'Hot', code: '#AC4362' },
  { name: 'Dragon Fruit', code: '#CC617F' },
  { name: 'Eros Pink', code: '#C84F68' },
  { name: 'Radish', code: '#A42E41' },
  { name: 'Cherries Jubilee', code: '#AB3C51' },
  { name: 'Heartthrob', code: '#A82E33' },
  { name: 'Real Red', code: '#BF2D32' },
  { name: 'Stop', code: '#C33A36' },
  { name: 'Positive Red', code: '#AD2C34' },
  { name: 'Comical Coral', code: '#F3D1C8' },
  { name: 'Cayenne', code: '#C04D35' },
  { name: 'Raucous Orange', code: '#C35530' },
  { name: 'Obstinate Orange', code: '#D7552A' },
  { name: 'Knockout Orange', code: '#E16F3E' },
  { name: 'Invigorate', code: '#E47237' },
  { name: 'Navel', code: '#EC8430' },
  { name: 'Osage Orange', code: '#F4A045' },
  { name: 'Carnival', code: '#EB882C' },
  { name: 'Solé', code: '#F7DDA1' },
  { name: 'Optimistic Yellow', code: '#F5E1A6' },
  { name: 'Daffodil', code: '#FAD97A' },
  { name: 'Decisive Yellow', code: '#FDCC4E' },
  { name: 'Cheerful', code: '#FFC723' },
  { name: 'Gusto Gold', code: '#F8AC1D' },
  { name: 'Goldfinch', code: '#FDB702' },
  { name: 'Forsythia', code: '#FFC801' },
  { name: 'Fun Yellow', code: '#F7E594' },
  { name: 'Lemon Twist', code: '#FED95D' },
  { name: 'Daisy', code: '#FED340' },
  { name: 'Confident Yellow', code: '#FECB01' },
  { name: 'Funky Yellow', code: '#EDD26F' },
  { name: 'Eye Catching', code: '#DDB835' },
  { name: 'Citronella', code: '#CBA901' },
  { name: 'Humorous Green', code: '#C6B836' },
  { name: 'Center Stage', code: '#B2C216' },
  { name: 'Electric Lime', code: '#9ABA25' },
  { name: 'Direct Green', code: '#3F8A24' },
  { name: 'Envy', code: '#358C3F' },
  { name: 'Lucky Green', code: '#238652' },
  { name: 'Greenbelt', code: '#017244' },
  { name: 'Green Vibes', code: '#D4E7C3' },
  { name: 'Tantalizing Teal', code: '#87DCCE' },
  { name: 'Nifty Turquoise', code: '#019187' },
  { name: 'Splashy', code: '#019196' },
  { name: 'Intense Teal', code: '#017680' },
  { name: 'Calypso', code: '#01B0BB' },
  { name: 'Undercool', code: '#7FC3E1' },
  { name: 'Dynamic Blue', code: '#0192C6' },
  { name: 'Blue Chip', code: '#016EA7' },
  { name: 'Hyper Blue', code: '#015F97' },
  { name: 'Blueblood', code: '#015086' },
  { name: 'Frank Blue', code: '#225288' },
  { name: 'Hyacinth Tint', code: '#C2CBE0' },
  { name: 'Morning Glory', code: '#3C4C80' },
  { name: 'Free Spirit', code: '#CAB2D2' },
  { name: 'Passionate Purple', code: '#795484' },
  { name: 'African Violet', code: '#665385' },
  { name: 'Fully Purple', code: '#514C7E' },
  { name: 'Jitterbug Jade', code: '#019D6E' },
  { name: 'Bohemian Black', code: '#3B373C' },
  { name: 'Domino', code: '#353337' },
  { name: 'Caviar', code: '#313031' },
  { name: 'Black Magic', code: '#323132' },
  { name: 'Inkwell', code: '#31363A' },
  { name: 'Black of Night', code: '#323639' },
  { name: 'Greenblack', code: '#373A3A' },
  { name: 'Ibis White', code: '#F2ECE6' },
  { name: 'Marshmallow', code: '#EEE9E0' },
  { name: 'Downy', code: '#EFE8DD' },
  { name: 'Toque White', code: '#E7E2DA' },
  { name: 'Snowbound', code: '#EDEAE5' },
  { name: 'Pure White', code: '#EDECE6' },
  { name: 'Extra White', code: '#EEEFEA' },
  { name: 'Ceiling Bright White', code: '#E9EBE7' },
  { name: 'Alabaster', code: '#EDEAE0' },
  { name: 'Pearly White', code: '#E8E3D9' },
  { name: 'White Duck', code: '#E5DFD2' },
  { name: 'Natural Choice', code: '#E3DED0' },
  { name: 'Creamy', code: '#EFE8DB' },
  { name: 'Ivory Lace', code: '#ECE5D8' },
  { name: 'Eider White', code: '#E2DED8' },
  { name: 'Repose Gray', code: '#CCC9C0' },
  { name: 'Mindful Gray', code: '#BCB7AD' },
  { name: 'Dorian Gray', code: '#ACA79E' },
  { name: 'Dovetail', code: '#908A83' },
  { name: 'Gauntlet Gray', code: '#78736E' },
  { name: 'Black Fox', code: '#4F4842' },
  { name: 'Simple White', code: '#DFD9D2' },
  { name: 'Alpaca', code: '#CCC5BD' },
  { name: 'Requisite Gray', code: '#B9B2A9' },
  { name: 'Functional Gray', code: '#ABA39A' },
  { name: 'Backdrop', code: '#867A6F' },
  { name: 'Griffin', code: '#6F6459' },
  { name: 'Hickory Smoke', code: '#564537' },
  { name: 'Incredible White', code: '#E3DED7' },
  { name: 'Agreeable Gray', code: '#D1CBC1' },
  { name: 'Anew Gray', code: '#BFB6AA' },
  { name: 'Mega Greige', code: '#ADA295' },
  { name: 'Warm Stone', code: '#887B6C' },
  { name: 'Brainstorm Bronze', code: '#74685A' },
  { name: 'Status Bronze', code: '#5C4D3C' },
  { name: 'Aesthetic White', code: '#E3DDD3' },
  { name: 'Accessible Beige', code: '#D1C7B8' },
  { name: 'Balanced Beige', code: '#C0B2A2' },
  { name: 'Tony Taupe', code: '#B1A290' },
  { name: 'Virtual Taupe', code: '#8A7A6A' },
  { name: 'Smokehouse', code: '#716354' },
  { name: 'Van Dyke Brown', code: '#564536' },
  { name: 'Shoji White', code: '#E6DFD3' },
  { name: 'Worldly Gray', code: '#CEC6BB' },
  { name: 'Amazing Gray', code: '#BEB5A9' },
  { name: 'Intellectual Gray', code: '#A8A093' },
  { name: 'Anonymous', code: '#817A6E' },
  { name: 'Porpoise', code: '#6B645B' },
  { name: 'Urbane Bronze', code: '#54504A' },
  { name: 'Nuance', code: '#E2E0D6' },
  { name: 'Useful Gray', code: '#CFCABD' },
  { name: 'Analytical Gray', code: '#BFB6A7' },
  { name: 'Gray Area', code: '#AFA696' },
  { name: 'Adaptive Shade', code: '#867E70' },
  { name: 'Oak Leaf Brown', code: '#645A4B' },
  { name: 'Enduring Bronze', code: '#554C3E' },
  { name: 'Reserved White', code: '#E0E0D9' },
  { name: 'Silver Strand', code: '#C8CBC4' },
  { name: 'Magnetic Gray', code: '#B2B5AF' },
  { name: 'Unusual Gray', code: '#A3A7A0' },
  { name: 'Attitude Gray', code: '#7C7D75' },
  { name: 'Night Owl', code: '#63655F' },
  { name: 'Rock Bottom', code: '#484C49' },
  { name: 'Nebulous White', code: '#DEDFDC' },
  { name: 'Passive', code: '#CBCCC9' },
  { name: 'Argos', code: '#BDBDB7' },
  { name: 'Gray Matters', code: '#A7A8A2' },
  { name: 'Cityscape', code: '#7F817E' },
  { name: 'Grizzle Gray', code: '#636562' },
  { name: 'Iron Ore', code: '#434341' },
  { name: 'Site White', code: '#DCDEDC' },
  { name: 'Gray Screen', code: '#C6CACA' },
  { name: 'Online', code: '#B0B5B5' },
  { name: 'Network Gray', code: '#A0A5A7' },
  { name: 'Software', code: '#7F8486' },
  { name: 'Web Gray', code: '#616669' },
  { name: 'Cyberspace', code: '#44484D' },
  { name: 'Original White', code: '#E2DEDB' },
  { name: 'Minute Mauve', code: '#CFC9C8' },
  { name: 'Ponder', code: '#BCB6B6' },
  { name: 'Quest Gray', code: '#ADA5A5' },
  { name: 'Sensuous Gray', code: '#837D7F' },
  { name: 'Stunning Shade', code: '#676064' },
  { name: 'Darkroom', code: '#443E40' },
  { name: 'Arcade White', code: '#F3EEE7' },
  { name: 'Futon', code: '#EDE6DB' },
  { name: 'White Flour', code: '#F4EFE5' },
  { name: 'Whitetail', code: '#F4EFE4' },
  { name: 'Cotton White', code: '#F7EFE3' },
  { name: 'Paperwhite', code: '#F7EFDE' },
  { name: 'Honied White', code: '#F8EEDB' },
  { name: 'Threshold Taupe', code: '#AC9A8A' },
  { name: 'Dry Dock', code: '#A18D7D' },
  { name: 'Sticks & Stones', code: '#A49689' },
  { name: 'Keystone Gray', code: '#9E9284' },
  { name: 'Manor House', code: '#665D57' },
  { name: 'Loggia', code: '#C4B7A5' },
  { name: 'Stone Lion', code: '#B3A491' },
  { name: 'Tavern Taupe', code: '#9C8A79' },
  { name: 'Tiki Hut', code: '#826F5E' },
  { name: 'Chateau Brown', code: '#5B4B44' },
  { name: 'Bungalow Beige', code: '#CDBFB0' },
  { name: 'Pavilion Beige', code: '#C5B6A4' },
  { name: 'Sanderling', code: '#A79582' },
  { name: 'Foothills', code: '#827466' },
  { name: 'Homestead Brown', code: '#6E5F53' },
  { name: 'Kestrel White', code: '#E0D6C8' },
  { name: 'Rivers Edge', code: '#DBCEBD' },
  { name: 'Beach House', code: '#C9B29C' },
  { name: 'Mexican Sand', code: '#AF9781' },
  { name: 'Plantation Shutters', code: '#6A5143' },
  { name: 'Dormer Brown', code: '#AD947C' },
  { name: 'Meadowlark', code: '#9F8267' },
  { name: 'Burnished Brandy', code: '#7C5C43' },
  { name: 'Dhurrie Beige', code: '#CABAA8' },
  { name: 'Tree Branch', code: '#8A7362' },
  { name: 'Maison Blanche', code: '#DFD2BF' },
  { name: 'Nantucket Dune', code: '#D0BFAA' },
  { name: 'Windsor Greige', code: '#C4B49C' },
  { name: 'Sand Beach', code: '#D4C5AD' },
  { name: 'Barcelona Beige', code: '#C4B39C' },
  { name: 'Canvas Tan', code: '#DCD1BF' },
  { name: 'Urban Putty', code: '#CFC0AB' },
  { name: 'Khaki Shade', code: '#C0AF97' },
  { name: 'Outerbanks', code: '#B7A48B' },
  { name: 'Sandy Ridge', code: '#A18E77' },
  { name: 'Bittersweet Stem', code: '#CBB49A' },
  { name: 'Irish Cream', code: '#E3D2B8' },
  { name: 'Tamarind', code: '#C0A588' },
  { name: 'Cork Wedge', code: '#C1A98A' },
  { name: 'Artisan Tan', code: '#B09879' },
  { name: 'Grecian Ivory', code: '#D8CFBE' },
  { name: 'Naturel', code: '#CBC0AD' },
  { name: 'Avenue Tan', code: '#BCB099' },
  { name: 'Fenland', code: '#AC9D83' },
  { name: 'Pier', code: '#63523D' },
  { name: 'Prairie Grass', code: '#B1A38E' },
  { name: 'Sandbar', code: '#CBBFAD' },
  { name: 'Portico', code: '#BBAB95' },
  { name: 'Studio Taupe', code: '#AD9C85' },
  { name: 'Resort Tan', code: '#907D66' },
  { name: 'Greek Villa', code: '#F0ECE2' },
  { name: 'Bauhaus Buff', code: '#E7DBCC' },
  { name: 'Fragile Beauty', code: '#E7D7C6' },
  { name: 'Steamed Milk', code: '#ECE1D1' },
  { name: 'Patience', code: '#E2D3BF' },
  { name: 'Crème', code: '#F4E8D2' },
  { name: 'Summer White', code: '#F4E9D6' },
  { name: 'Medici Ivory', code: '#F3E9D7' },
  { name: 'Décor White', code: '#F2E5CF' },
  { name: 'Impressive Ivory', code: '#F4DEC3' },
  { name: 'Lemon Meringue', code: '#F5EACC' },
  { name: 'Roman Column', code: '#F6F0E2' },
  { name: 'Restful White', code: '#EEE8D7' },
  { name: 'Polar Bear', code: '#E8DFCA' },
  { name: 'Oyster Bar', code: '#DBD0BB' },
  { name: 'Westhighland White', code: '#F3EEE3' },
  { name: 'Natural Tan', code: '#DCD2C3' },
  { name: 'Neutral Ground', code: '#E2DACA' },
  { name: 'Stucco', code: '#DCCFBA' },
  { name: 'Egret White', code: '#DFD9CF' },
  { name: 'Casa Blanca', code: '#EDE1CE' },
  { name: 'Lotus Pod', code: '#E7D7C2' },
  { name: 'Eaglet Beige', code: '#E9D9C0' },
  { name: 'Echelon Ecru', code: '#E7D8BE' },
  { name: 'Chopsticks', code: '#E0D1B8' },
  { name: 'Blackberry', code: '#533640' },
  { name: 'Borscht', code: '#72353D' },
  { name: 'Alaea', code: '#81585B' },
  { name: 'Carnelian', code: '#573E3E' },
  { name: 'Salute', code: '#803532' },
  { name: 'Wild Currant', code: '#7C3239' },
  { name: 'Red Theatre', code: '#6E3637' },
  { name: 'Sun Dried Tomato', code: '#692B2B' },
  { name: 'Stolen Kiss', code: '#813235' },
  { name: 'Antique Red', code: '#9F4442' },
  { name: 'Show Stopper', code: '#A42E37' },
  { name: 'Habanero Chile', code: '#B8473D' },
  { name: 'Red Barn', code: '#7C453D' },
  { name: 'Crabby Apple', code: '#753531' },
  { name: 'Rustic Red', code: '#703229' },
  { name: 'Carriage Door', code: '#6E423E' },
  { name: 'Sommelier', code: '#5D3736' },
  { name: 'Only Natural', code: '#E2D3C4' },
  { name: 'Sierra Redwood', code: '#924E3C' },
  { name: 'Brick Paver', code: '#93402F' },
  { name: 'Bolero', code: '#903934' },
  { name: 'Dockside Blue', code: '#A0B3BC' },
  { name: 'Indigo Batik', code: '#3E5063' },
  { name: 'Poolhouse', code: '#8095A0' },
  { name: 'Smoky Blue', code: '#596E79' },
  { name: 'Gale Force', code: '#35454E' },
  { name: 'Blue Cruise', code: '#6591A8' },
  { name: 'Santorini Blue', code: '#416D83' },
  { name: 'Adrift', code: '#87AAB9' },
  { name: 'Georgian Revival Blue', code: '#5B8D9F' },
  { name: 'Turkish Tile', code: '#3E758A' },
  { name: 'Tranquil Aqua', code: '#7C9AA0' },
  { name: 'Mountain Stream', code: '#679199' },
  { name: 'Aqua-Sphere', code: '#9CB0B3' },
  { name: 'St. Bart\'s', code: '#577C88' },
  { name: 'Sea Serpent', code: '#3E4B54' },
  { name: 'Breezy', code: '#A0AEAF' },
  { name: 'Mediterranean', code: '#60797D' },
  { name: 'Deep Sea Dive', code: '#376167' },
  { name: 'Labradorite', code: '#657B83' },
  { name: 'Seaworthy', code: '#314D58' },
  { name: 'Silvermist', code: '#B0B8B2' },
  { name: 'Homburg Gray', code: '#666D69' },
  { name: 'Cascades', code: '#273E3E' },
  { name: 'Slate Tile', code: '#606E74' },
  { name: 'Mount Etna', code: '#3D484C' },
  { name: 'Zurich White', code: '#E6E1D9' },
  { name: 'White Heron', code: '#E7E1D7' },
  { name: 'Windfresh White', code: '#DED8CF' },
  { name: 'Grapy', code: '#786E70' },
  { name: 'Raisin', code: '#392B2D' },
  { name: 'City Loft', code: '#DFDAD1' },
  { name: 'Modern Gray', code: '#D6CEC3' },
  { name: 'Taupe Tone', code: '#ADA090' },
  { name: 'Pediment', code: '#D3CCC4' },
  { name: 'Palisade', code: '#AA9E95' },
  { name: 'Origami White', code: '#E5E2DA' },
  { name: 'Oyster White', code: '#E2DDD0' },
  { name: 'Jogging Path', code: '#C0B9A9' },
  { name: 'Ethereal Mood', code: '#AEA594' },
  { name: 'Fawn Brindle', code: '#A7A094' },
  { name: 'Colonnade Gray', code: '#C6C0B6' },
  { name: 'Pavestone', code: '#A0998F' },
  { name: 'Pussywillow', code: '#B2ADA4' },
  { name: 'Gateway Gray', code: '#B2AC9C' },
  { name: 'Thunder Gray', code: '#57534C' },
  { name: 'First Star', code: '#DAD9D4' },
  { name: 'Crushed Ice', code: '#D6D3CC' },
  { name: 'Big Chill', code: '#D0CEC9' },
  { name: 'Silverplate', code: '#C2C0BA' },
  { name: 'Ellie Gray', code: '#AAA9A4' },
  { name: 'Front Porch', code: '#CCCCC5' },
  { name: 'Mineral Deposit', code: '#ABB0AC' },
  { name: 'Silverpointe', code: '#D1D2CB' },
  { name: 'Lattice', code: '#CECEC6' },
  { name: 'Stamped Concrete', code: '#A0A09A' },
  { name: 'Rhinestone', code: '#DEE0DE' },
  { name: 'Tinsmith', code: '#C5C8C4' },
  { name: 'Gray Clouds', code: '#B7B7B2' },
  { name: 'Gris', code: '#A5A9A8' },
  { name: 'Earl Grey', code: '#969A96' },
  { name: 'Reflection', code: '#D3D5D3' },
  { name: 'Evening Shadow', code: '#C9CCCD' },
  { name: 'Monorail Silver', code: '#B8BCBB' },
  { name: 'Steely Gray', code: '#90979B' },
  { name: 'Wall Street', code: '#656D73' },
  { name: 'Fleur de Sel', code: '#DCDDD8' },
  { name: 'Zircon', code: '#CAC9C6' },
  { name: 'March Wind', code: '#BAB9B6' },
  { name: 'Summit Gray', code: '#959491' },
  { name: 'Gray Shingle', code: '#949392' },
  { name: 'On the Rocks', code: '#D0CEC8' },
  { name: 'Knitting Needles', code: '#C3C1BC' },
  { name: 'Pewter Cast', code: '#9B9893' },
  { name: 'Peppercorn', code: '#585858' },
  { name: 'Sealskin', code: '#48423C' },
  { name: 'Paper Lantern', code: '#F2E0C4' },
  { name: 'Gold Vessel', code: '#EABA8A' },
  { name: 'Cottage Cream', code: '#EDDBBD' },
  { name: 'Golden Gate', code: '#D9AD7F' },
  { name: 'Lanyard', code: '#C09972' },
  { name: 'Tea Light', code: '#F8E4C2' },
  { name: 'Bee\'s Wax', code: '#EABF86' },
  { name: 'Buff', code: '#F1DFC1' },
  { name: 'Concord Buff', code: '#EDD6B1' },
  { name: 'White Raisin', code: '#E5C28B' },
  { name: 'Hinoki', code: '#F8DDB7' },
  { name: 'August Moon', code: '#E7C7A0' },
  { name: 'Sundew', code: '#E1CDAE' },
  { name: 'Row House Tan', code: '#D2BB9D' },
  { name: 'Townhall Tan', code: '#C3AA8C' },
  { name: 'Pale Yellow', code: '#E3C9A1' },
  { name: 'Cupola Yellow', code: '#DCBC8E' },
  { name: 'Stonebriar', code: '#CBA97E' },
  { name: 'Dromedary Camel', code: '#CAAD87' },
  { name: 'Mesa Tan', code: '#BD9C77' },
  { name: 'Toasted Pine Nut', code: '#DCC6A6' },
  { name: 'Safari', code: '#CCB18B' },
  { name: 'Straw Harvest', code: '#DBC8A2' },
  { name: 'Rustic City', code: '#BA9A67' },
  { name: 'Olde World Gold', code: '#8F6C3E' },
  { name: 'Cavern Clay', code: '#AC6B53' },
  { name: 'Spiced Cider', code: '#B0785C' },
  { name: 'Earthen Jug', code: '#A85E39' },
  { name: 'Tower Tan', code: '#D5B59B' },
  { name: 'Wheat Penny', code: '#976B53' },
  { name: 'Copper Wire', code: '#C67B57' },
  { name: 'Copper Pot', code: '#B16A37' },
  { name: 'Brandywine', code: '#A56C4A' },
  { name: 'Pueblo', code: '#E6D0BD' },
  { name: 'Townhouse Tan', code: '#DFC8B5' },
  { name: 'Tawny Tan', code: '#CCB299' },
  { name: 'Oak Barrel', code: '#BFA287' },
  { name: 'Pottery Urn', code: '#AA866E' },
  { name: 'Croissant', code: '#DBC5A7' },
  { name: 'Ligonier Tan', code: '#D2B18F' },
  { name: 'Oak Creek', code: '#BB8D6B' },
  { name: 'Fresco Cream', code: '#D8C4AE' },
  { name: 'Deer Valley', code: '#C7A485' },
  { name: 'Crescent Cream', code: '#EDD1B1' },
  { name: 'Travertine', code: '#ECD3B3' },
  { name: 'Colony Buff', code: '#DDC6AB' },
  { name: 'Canoe', code: '#B7987B' },
  { name: 'Yearling', code: '#AD896A' },
  { name: 'Lemon Verbena', code: '#9D986F' },
  { name: 'Koi Pond', code: '#B9B292' },
  { name: 'Green Sprout', code: '#A29F80' },
  { name: 'Edamame', code: '#827C5A' },
  { name: 'Forestwood', code: '#4D5346' },
  { name: 'San Antonio Sage', code: '#A69474' },
  { name: 'Lemongrass', code: '#C8BD98' },
  { name: 'Bamboo Shoot', code: '#B3A479' },
  { name: 'Olive Grove', code: '#857C5D' },
  { name: 'Palm Leaf', code: '#635936' },
  { name: 'Garden Sage', code: '#B1A584' },
  { name: 'Meadow Trail', code: '#8D8168' },
  { name: 'Cargo Pants', code: '#CDC4AE' },
  { name: 'Herbal Wash', code: '#A49B82' },
  { name: 'Messenger Bag', code: '#7D745E' },
  { name: 'Willow Tree', code: '#AAAD9C' },
  { name: 'Agate Green', code: '#8EA486' },
  { name: 'Mountain Road', code: '#868578' },
  { name: 'Zeus', code: '#99907E' },
  { name: 'Muddled Basil', code: '#5A5243' },
  { name: 'Rushing River', code: '#A19C8F' },
  { name: 'Recycled Glass', code: '#BDC0A0' },
  { name: 'Green Earth', code: '#9A9883' },
  { name: 'Laurel Woods', code: '#44493D' },
  { name: 'Olympic Range', code: '#424C44' },
  { name: 'High Reflective White', code: '#F7F7F1' },
  { name: 'Shell White', code: '#F0EBE0' },
  { name: 'Audrey\'s Blush', code: '#AE8087' },
  { name: 'Carley\'s Rose', code: '#A87376' },
  { name: 'Rita\'s Rouge', code: '#BA7176' },
  { name: 'Coral Rose', code: '#C37F7A' },
  { name: 'Coral Clay', code: '#BF796E' },
  { name: 'Rojo Dust', code: '#B57466' },
  { name: 'Melón Meloso', code: '#F2B88C' },
  { name: 'Bellini Fizz', code: '#F5C78E' },
  { name: 'Subdued Sienna', code: '#CC896C' },
  { name: 'Windswept Canyon', code: '#DBA480' },
  { name: 'Sun Bleached Ochre', code: '#E3AB7B' },
  { name: 'Polvo de Oro', code: '#E8B87F' },
  { name: 'Olden Amber', code: '#EEB76B' },
  { name: 'Pollen Powder', code: '#FBD187' },
  { name: 'They call it Mellow', code: '#FBE4B3' },
  { name: 'La Luna Amarilla', code: '#FDDFA0' },
  { name: 'Sunny Veranda', code: '#FEDF94' },
  { name: 'Honey Bees', code: '#FBD682' },
  { name: 'Golden Plumeria', code: '#FBD073' },
  { name: 'Rayo de Sol', code: '#F4C454' },
  { name: 'Naples Yellow', code: '#F6D58F' },
  { name: 'Yellow Bird', code: '#F1CD7B' },
  { name: 'Dakota Wheat', code: '#E1BD8E' },
  { name: 'Vintage Gold', code: '#CBA576' },
  { name: 'Coriander Powder', code: '#BA9C75' },
  { name: 'Tarnished Trumpet', code: '#D5B176' },
  { name: 'Pale Moss', code: '#DCC797' },
  { name: 'Dusted Olive', code: '#BEA775' },
  { name: 'Cool Avocado', code: '#C4B47D' },
  { name: 'Limón Fresco', code: '#CEBC55' },
  { name: 'Primavera', code: '#D2D083' },
  { name: 'Stay in Lime', code: '#9FAC5C' },
  { name: 'Oh Pistachio', code: '#ABCA99' },
  { name: 'Seawashed Glass', code: '#A9C095' },
  { name: 'Frosted Emerald', code: '#78B185' },
  { name: 'Retro Mint', code: '#9FCDB1' },
  { name: 'Baby Bok Choy', code: '#BBB98A' },
  { name: 'Cucuzza Verde', code: '#9BA373' },
  { name: 'Broccoflower', code: '#8FA277' },
  { name: 'Reseda Green', code: '#75946B' },
  { name: 'Parisian Patina', code: '#7D9B89' },
  { name: 'Verdigreen', code: '#81A595' },
  { name: 'Aquastone', code: '#89C6B7' },
  { name: 'Little Blue Box', code: '#8AC5BA' },
  { name: 'Bora Bora Shore', code: '#92D0D0' },
  { name: 'Gentle Aquamarine', code: '#97CBD2' },
  { name: 'After the Rain', code: '#8BC4D1' },
  { name: 'Surfin\'', code: '#73C0D2' },
  { name: 'Sky Fall', code: '#89C6DF' },
  { name: 'Vintage Vessel', code: '#94B2A6' },
  { name: 'Aquaverde', code: '#A3C0BD' },
  { name: 'Blithe Blue', code: '#90BDBD' },
  { name: 'Agua Fría', code: '#9FC5CC' },
  { name: 'Little Boy Blu', code: '#C7D8DB' },
  { name: 'Billowy Breeze', code: '#AFC7CD' },
  { name: 'French Moire', code: '#9FBBC3' },
  { name: 'Aquitaine', code: '#88ABB4' },
  { name: 'Secret Cove', code: '#68909D' },
  { name: 'Silken Peacock', code: '#427584' },
  { name: 'Connor\'s Lakefront', code: '#175A6C' },
  { name: 'Rest Assured', code: '#9BBFC9' },
  { name: 'Bluebird Feather', code: '#6F9DB3' },
  { name: 'Porch Ceiling', code: '#9BC8DE' },
  { name: 'Bluesy Note', code: '#7C9AB5' },
  { name: 'Perfect Periwinkle', code: '#6487B0' },
  { name: 'Agapanthus', code: '#BBC5DE' },
  { name: 'Forever Lilac', code: '#AFA5C7' },
  { name: 'Berry Frappé', code: '#B3A1C6' },
  { name: 'Veri Berri', code: '#937496' },
  { name: 'Baby Blue Eyes', code: '#83A2B4' },
  { name: 'Dyer\'s Woad', code: '#7B99B0' },
  { name: 'Dried Lavender', code: '#8595AA' },
  { name: 'Dusty Heather', code: '#8990A3' },
  { name: 'Gentle Grape', code: '#908A9B' },
  { name: 'Berry Cream', code: '#9A8CA2' },
  { name: 'Ruby Violet', code: '#9B7E8B' },
  { name: 'Rosaline Pearl', code: '#A38887' },
  { name: 'Cocoa Berry', code: '#A08882' },
  { name: 'Velvety Chestnut', code: '#A2877D' },
  { name: 'Hushed Auburn', code: '#A8857A' },
  { name: 'Redend Point', code: '#AE8E7E' },
  { name: 'Chocolate Powder', code: '#A58C7B' },
  { name: 'Dusted Truffle', code: '#9C8373' },
  { name: 'Cocoa Whip', code: '#A08E7E' },
  { name: 'Touch of Sand', code: '#D5C7BA' },
  { name: 'Cool Beige', code: '#C6B5A7' },
  { name: 'Smoky Beige', code: '#B9A796' },
  { name: 'Utaupeia', code: '#A58F7B' },
  { name: 'Llama Wool', code: '#917864' },
  { name: 'Caraïbe', code: '#785F4C' },
  { name: 'Half-Caff', code: '#604C3D' },
  { name: 'Iced Mocha', code: '#A3846C' },
  { name: 'Nearly Brown', code: '#A88E76' },
  { name: 'Playa Arenosa', code: '#DCC7B3' },
  { name: 'Ginger Root', code: '#D2B79E' },
  { name: 'Beige Intenso', code: '#C5A88D' },
  { name: 'Soft Fawn', code: '#B59778' },
  { name: 'Baked Cookie', code: '#89674A' },
  { name: 'Saddle Up', code: '#725237' },
  { name: 'Umber Rust', code: '#765138' },
  { name: 'Tres Naturale', code: '#DCC7AD' },
  { name: 'Quinoa', code: '#CFB597' },
  { name: 'Farro', code: '#C1A485' },
  { name: 'Woven Wicker', code: '#B99974' },
  { name: 'Almond Roca', code: '#A78361' },
  { name: 'El Caramelo', code: '#946E48' },
  { name: 'Über Umber', code: '#7B5838' },
  { name: 'Double Latte', code: '#A78C71' },
  { name: 'Natural Linen', code: '#DFD3C3' },
  { name: 'Malabar', code: '#CFBEA9' },
  { name: 'Antler Velvet', code: '#C0AD96' },
  { name: 'Song Thrush', code: '#AF987F' },
  { name: 'Mudslide', code: '#A08568' },
  { name: 'Fallen Leaves', code: '#8F7659' },
  { name: 'Cowboy Boots', code: '#695239' },
  { name: 'Serengeti Grass', code: '#AB9579' },
  { name: 'Urban Jungle', code: '#A4947E' },
  { name: 'Tarnished Treasure', code: '#B9A47E' },
  { name: 'Dirty Martini', code: '#DDD0B6' },
  { name: 'Tumblin\' Tumbleweed', code: '#CDBB9C' },
  { name: 'Sawgrass Basket', code: '#C3B090' },
  { name: 'Dried Edamame', code: '#B19F80' },
  { name: 'Barro Verde', code: '#9F8E71' },
  { name: 'Verde Marrón', code: '#877459' },
  { name: 'Oliva Oscuro', code: '#665439' },
  { name: 'Honed Soapstone', code: '#9D9887' },
  { name: 'At Ease Soldier', code: '#9E9985' },
  { name: 'Green Onyx', code: '#989A82' },
  { name: 'Jade Dragon', code: '#909886' },
  { name: 'Evergreen Fog', code: '#95978A' },
  { name: 'Cornwall Slate', code: '#949488' },
  { name: 'Acacia Haze', code: '#969C92' },
  { name: 'Jasper Stone', code: '#8D9E97' },
  { name: 'Delft', code: '#8B9FA0' },
  { name: 'Whirlpool', code: '#80969D' },
  { name: 'Lullaby', code: '#CBD4D4' },
  { name: 'Niebla Azul', code: '#B6C3C4' },
  { name: 'Stardew', code: '#A6B2B5' },
  { name: 'Debonair', code: '#90A0A6' },
  { name: 'Blustery Sky', code: '#6F848C' },
  { name: 'Waterloo', code: '#536872' },
  { name: 'Moscow Midnight', code: '#204652' },
  { name: 'Cadet', code: '#91999C' },
  { name: 'Moonmist', code: '#C9D9E0' },
  { name: 'Sleepy Hollow', code: '#B7C9D1' },
  { name: 'Faded Flaxflower', code: '#9EB4C0' },
  { name: 'Favorite Jeans', code: '#8AA3B1' },
  { name: 'Smoky Azurite', code: '#708D9E' },
  { name: 'Inky Blue', code: '#4E7287' },
  { name: 'Endless Sea', code: '#32586E' },
  { name: 'Daphne', code: '#899CAA' },
  { name: 'Let it Rain', code: '#979FA5' },
  { name: 'Moonlit Orchid', code: '#949194' },
  { name: 'Perle Noir', code: '#4F4D51' },
  { name: 'Slate Violet', code: '#989192' },
  { name: 'Gris Morado', code: '#8F8A91' },
  { name: 'Autumn Orchid', code: '#9D9093' },
  { name: 'Coquina', code: '#9D8D8E' },
  { name: 'Auger Shell', code: '#9F9291' },
  { name: 'Armadillo', code: '#9E9089' },
  { name: 'Dustblu', code: '#959BA0' },
  { name: 'African Gray', code: '#939899' },
  { name: 'Tin Lizzie', code: '#939591' },
  { name: 'Illusive Green', code: '#92948D' },
  { name: 'Gossamer Veil', code: '#D3CEC4' },
  { name: 'Drift of Mist', code: '#DCD8D0' },
  { name: 'Polished Concrete', code: '#9E9793' },
  { name: 'Elephant Ear', code: '#988F85' },
  { name: 'Chatura Gray', code: '#A09287' },
  { name: 'Acier', code: '#9E9991' },
  { name: 'Felted Wool', code: '#979083' },
  { name: 'Studio Clay', code: '#958D7F' },
  { name: 'Shiitake', code: '#C8BCAB' },
  { name: 'Moth Wing', code: '#A0907F' },
  { name: 'Deep Forest Brown', code: '#393437' },
  { name: 'Dress Blues', code: '#2B4360' },
  { name: 'Salty Dog', code: '#234058' },
  { name: 'In the Navy', code: '#283849' },
  { name: 'Anchors Aweigh', code: '#2B3441' },
  { name: 'Aged White', code: '#E8DECD' },
  { name: 'Rojo Marrón', code: '#4B3029' },
  { name: 'Dark Clove', code: '#4C3D31' },
  { name: 'Foxhall Green', code: '#454B40' },
  { name: 'Marea Baja', code: '#2E5464' },
  { name: 'Caramelized', code: '#C29871' }
];

export default swPaintColors;